import { useNavigate } from 'react-router-dom';

import { CuroAppRoute } from 'enums/curo/CuroAppRoute';
import CuroAuthorizedLayout from 'layout/CuroAuthorizedLayout';
import {
  ApplicationDeclinedPage,
  ApplicationIsNotApprovedNOAA,
  ApplicationIsNotApprovedPage,
  CongratsPage,
  ContactSupportPage,
  FundingFailedPage,
  VerificationErrorPage,
  ApplicationRefiScorePage,
  ApplicationOnlineOriginationFailedPage,
  RefiApplicationExpiredPage,
  RefiApplicationInvalidPage,
  ActiveLoanOrPriorChangeOffPage,
  IneligibleZipCodeEndPage,
  NoPreScreenedOfferFoundPage,
} from 'pages/CuroPages/EndPages';

import ApplicationProcessSteps from './constants';
import AdditionalDocumentsSubmissionStep from './steps/AdditionalDocumentsSubmissionStep';
import ApplicationDetailsSubmissionStep from './steps/ApplicationDetailsSubmissionStep';
import ApplicationPreliminaryCheckStep from './steps/ApplicationPreliminaryCheckStep';
import ApplicationRefiScoreCheckStep from './steps/ApplicationRefiScoreCheckStep';
import GenerateLoanOffersStep from './steps/GenerateLoanOffersStep';
import SignLoanAgreementStep from './steps/SignLoanAgreementStep';
import VerificationProcessStep from './steps/VerificationProcessStep';
import { useApplicationProcessStep } from './useApplicationProcessStep';

const ApplicationProcess = () => {
  const currentStep = useApplicationProcessStep();
  const navigate = useNavigate();

  if (currentStep === ApplicationProcessSteps.ApplicationNotFoundPageStep) {
    navigate(CuroAppRoute.NotFound);
  }

  const renderStep = () => {
    switch (currentStep) {
      case ApplicationProcessSteps.VerificationProcessStep:
        return <VerificationProcessStep />;
      case ApplicationProcessSteps.ApplicationDeclinedStep:
        return <ApplicationDeclinedPage />;
      case ApplicationProcessSteps.ApplicationPreliminaryCheckStep:
        return <ApplicationPreliminaryCheckStep />;
      case ApplicationProcessSteps.ApplicationRefiScoreStep:
        return <ApplicationRefiScoreCheckStep />;
      case ApplicationProcessSteps.ApplicationDetailsSubmissionStep:
        return <ApplicationDetailsSubmissionStep />;
      case ApplicationProcessSteps.GenerateLoanOfferStep:
        return <GenerateLoanOffersStep />;
      case ApplicationProcessSteps.AdditionalDocumentsSubmissionStep:
        return <AdditionalDocumentsSubmissionStep />;
      case ApplicationProcessSteps.SignLoanAgreementStep:
        return <SignLoanAgreementStep />;
      case ApplicationProcessSteps.ContactSupportStep:
        return <ContactSupportPage />;
      case ApplicationProcessSteps.FundingFailedStep:
        return <FundingFailedPage />;
      case ApplicationProcessSteps.FundedStep:
        return <CongratsPage />;
      case ApplicationProcessSteps.ApplicationIsNotApprovedNOAAStep:
        return <ApplicationIsNotApprovedNOAA />;
      case ApplicationProcessSteps.ApplicationOnlineOriginationFailedStep:
        return <ApplicationOnlineOriginationFailedPage />;
      case ApplicationProcessSteps.FailedVerificationStep:
        return <VerificationErrorPage />;
      case ApplicationProcessSteps.ApplicationIsNotApprovedStep:
        return <ApplicationIsNotApprovedPage />;
      case ApplicationProcessSteps.ApplicationRefiScoreDeclinedStep:
        return <ApplicationRefiScorePage />;
      case ApplicationProcessSteps.RefiApplicationExpiredStep:
        return <RefiApplicationExpiredPage />;
      case ApplicationProcessSteps.RefiApplicationInvalidStep:
        return <RefiApplicationInvalidPage />;
      case ApplicationProcessSteps.ActiveLoanOrPriorChangeOffPageStep:
        return <ActiveLoanOrPriorChangeOffPage />;
      case ApplicationProcessSteps.OrganicTrafficIneligibleZipCode:
        return <IneligibleZipCodeEndPage />;
      case ApplicationProcessSteps.NoPreScreenedOfferFound:
        return <NoPreScreenedOfferFoundPage />;
      default:
        return null as never;
    }
  };

  return <CuroAuthorizedLayout>{renderStep()}</CuroAuthorizedLayout>;
};

export default ApplicationProcess;
